import React from 'react';
import { FormDialog } from '../../../form-dialog/form-dialog';
import { SingleSelect } from '../../../single-select/single-select';
import { Checkbox } from '../../../checkbox/checkbox';
import { Row } from '../../../row/row';
import { Cell } from '../../../cell/cell';
import { ClassroomDto } from '../../../../api-service/clients/auto-generated-clients';
import { IFutureLessonsOption } from './change-course-educators-dialog-component';

export interface IChangeCourseClassroomDialogComponentProps {
  title: string;
  description?: string;
  classrooms: ClassroomDto[];
  classroomId?: string;
  futureLessonsOption?: IFutureLessonsOption;
  isLoadingClassrooms: boolean;
  isSaving: boolean;
  onClassroomChange: (classroom?: ClassroomDto) => void;
  onConfirm: () => void;
  onClose: () => void;
}

function renderClassroomOption(optionProps: object, classroom: ClassroomDto) {
  return (
    <li {...optionProps} key={classroom.classroomId}>
      {classroom.name}
    </li>
  );
}

export function ChangeCourseClassroomDialogComponent({
  title,
  description,
  classrooms,
  classroomId,
  futureLessonsOption,
  isLoadingClassrooms,
  isSaving,
  onClassroomChange,
  onConfirm,
  onClose,
}: IChangeCourseClassroomDialogComponentProps) {
  return (
    <FormDialog
      open
      title={title}
      confirmButtonText="Udfør"
      cancelButtonText="Afbryd"
      isLoading={isSaving}
      isValid={!!classroomId && !isLoadingClassrooms}
      onConfirmClick={onConfirm}
      onCancelClick={onClose}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      {description && <p>{description}</p>}
      <Row>
        <Cell size="full">
          <SingleSelect<ClassroomDto>
            label="Lokale"
            placeholder="Fremsøg lokale"
            value={classrooms.find(classroom => classroom.classroomId === classroomId)}
            options={classrooms}
            getOptionLabel={classroom => classroom.name}
            renderOption={renderClassroomOption}
            onChange={onClassroomChange}
            loading={isLoadingClassrooms}
            required
            variant="outlined"
          />
        </Cell>
        {futureLessonsOption && (
          <Cell size="full">
            <Checkbox checked={futureLessonsOption.checked} onChange={futureLessonsOption.onToggle} label={futureLessonsOption.label} />
            <p>{futureLessonsOption.description}</p>
          </Cell>
        )}
      </Row>
    </FormDialog>
  );
}
